module.exports = __webpack_public_path__ + "media/bootstrap-icons/diamond-6920f77f.svg";